/** Timetable identity colors. Index uses the complete friend list, never selection order. */
const FRIEND_COLORS = ['#087f5b', '#bd491d', '#7656bd', '#176fbc', '#b14077', '#796018'] as const;
export function friendOverlayColor(index: number): string {
  return FRIEND_COLORS[Math.abs(index) % FRIEND_COLORS.length];
}
